import {
  type GraphEdgeSettings,
  type TopologyGraphPreset,
  type TopologyGraphSettings,
  assertType,
  nonEmptyArray,
} from '@ipfabric/utils';

export const clearSettings = <
  T extends TopologyGraphPreset | TopologyGraphSettings,
>(
  settings: T,
): T => {
  const nonEmptyEdges = settings.edges.filter(
    (edge: GraphEdgeSettings): boolean =>
      edge.type === 'protocol' ||
      (edge.type === 'group' && edge.children.length > 0),
  );
  assertType(nonEmptyArray.isNonEmpty, nonEmptyEdges);
  return {
    ...settings,
    edges: nonEmptyEdges,
  };
};
